import React from 'react'
import styles from './MoreOptions.module.css'
import UpgradeBadge from '../../../UpgradeBadge/UpgradeBadge'
import { isCustomDomain } from '../../../../utils/general'
import { isPDF, addUpgradeReason } from '../../../../utils/general'

const Item = ({ icon, alt, label, onClick, disabled, onUpgrade, hidden }) => {
  const handleUpgrade = () => {
    addUpgradeReason(label)
    onUpgrade()
  }

  if (hidden) return null

  return (
    <div className={`${styles.contentBox} ${disabled ? styles.disabled : ''}`} onClick={!disabled ? onClick : null}>
      <img src={`/assets/icons/${icon}`} alt={alt} className={styles.img} />
      <span className={styles.contentText}>{label}</span>
      <UpgradeBadge show={disabled} onUpgrade={handleUpgrade} />
    </div>
  )
}

const MoreOptions = (props) => {
  const {
    onEditHTML,
    onEditPDF,
    onArchive,
    onDownload,
    onDownloadAll,
    onAnalytics,
    onQRCode,
    onDelete,
    onCopy,
    onCopyDirectLink,
    onReplaceFile,
    onAddCustomDomain,
    onIntegrations,
    type,
    siteType,
    onEmbed,
    onCustomisePasswordPage,
    passwordProtected,
    enableEmailGate,
    inPreviewMode,
    onShare,
    trial,
    link,
    onUpgrade,
    disabled,
    onAssignToSpace,
    hasSpaces,
    onExportEmails,
    onViewVersions,
    linkId,
    wasmerDnsRecord,
    isPresignedUpload,
    onAnalyseSite,
    onClearCache
  } = props

  const phpFile = link?.includes('tiiny.io')
  const customDomainLink = link ? isCustomDomain(link) : false
  const isCollection = siteType === 'multiple'

  if (disabled) {
    // Render only the "Delete" item if disabled is true
    return (
      <div className={styles.menu}>
        <div className={styles.contentContainer}>
          <Item icon="trash.svg" alt="delete" label="Delete" onClick={onDelete} data-testid="delete-option" />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.menu}>
      <div className={styles.contentContainer}>
        <Item icon="copy-link.svg" alt="copy link" label="Copy link" onClick={onCopy} hidden={inPreviewMode} />
        <Item
          icon="download-file.svg"
          alt="downloadlink"
          label="Copy PDF download link"
          onClick={onCopyDirectLink}
          hidden={trial || phpFile || inPreviewMode || !isPDF({ type })}
        />
        <Item icon="share.svg" alt="sharelink" label="Share link" onClick={onShare} hidden={inPreviewMode} />
        <Item
          icon="qr-code.svg"
          alt="qrcode"
          label="View QR code"
          onClick={onQRCode}
          disabled={inPreviewMode}
          onUpgrade={onUpgrade}
        />
        <Item
          icon="embed.svg"
          alt="embed"
          label="Embed this link"
          onClick={onEmbed}
          disabled={inPreviewMode}
          onUpgrade={onUpgrade}
        />
        {!customDomainLink && (
          <Item
            icon={wasmerDnsRecord ? 'details.svg' : 'custom-domain.svg'}
            alt="Domain"
            label={wasmerDnsRecord ? 'View DNS records' : 'Publish to custom domain'}
            onClick={onAddCustomDomain}
          />
        )}
      </div>
      {!phpFile && (
        <div className={styles.contentContainer}>
          <Item icon="chart-bar.svg" alt="analytics" label="View analytics" onClick={onAnalytics} />
          {enableEmailGate && linkId && (
            <Item
              icon="download-white.svg"
              alt="export emails"
              label="Download collected emails"
              onClick={onExportEmails}
            />
          )}
        </div>
      )}
      <div className={styles.contentContainer}>
        <Item icon="power.svg" alt="integrations" label="Integrations" onClick={onIntegrations} />
      </div>
      <div className={styles.contentContainer}>
        {!isCollection && (
          <Item
            icon="edit.svg"
            alt="edit"
            label={type?.includes('pdf') ? 'Edit PDF' : 'Edit site'}
            onClick={type?.includes('pdf') ? onEditPDF : onEditHTML}
            onUpgrade={onUpgrade}
            hidden={phpFile}
          />
        )}

        <Item icon="replace.svg" alt="replace" label="Replace existing file" onClick={onReplaceFile} />
        <Item
          icon="sync.svg"
          alt="clear cache"
          label="Clear cache"
          onClick={onClearCache}
          hidden={!customDomainLink || !onClearCache}
        />
        <Item
          icon="spanner.svg"
          alt="analyze site"
          label="Analyze site"
          onClick={onAnalyseSite}
          hidden={phpFile || isPDF({ type }) || !onAnalyseSite}
        />
        {(passwordProtected || enableEmailGate) && (
          <Item
            icon="settings.svg"
            alt="Customize password page"
            label={`Customize ${enableEmailGate ? 'email capture' : 'password'} page`}
            onClick={onCustomisePasswordPage}
            hidden={phpFile}
          />
        )}
      </div>
      <div className={styles.contentContainer}>
        <Item
          icon="details.svg"
          alt="versions"
          label="Versions"
          onClick={onViewVersions}
          hidden={phpFile || !onViewVersions || isPresignedUpload}
        />
        <Item
          icon="download-white.svg"
          alt="download"
          label="Download"
          onClick={onDownloadAll}
          hidden={!onDownloadAll}
        />
        <Item icon="archive-box.svg" alt="archive" label="Archive" onClick={onArchive} hidden={phpFile} />
        {hasSpaces && (
          <Item icon="folder.svg" alt="assign to space" label="Assign to a space" onClick={onAssignToSpace} />
        )}
        <Item icon="trash.svg" alt="delete" label="Delete" onClick={onDelete} data-testid="delete-option" />
      </div>
    </div>
  )
}

export default MoreOptions
